import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MeusImoveisPage } from './meus-imoveis.page';

const routes: Routes = [
  { path: '', component: MeusImoveisPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MeusImoveisPageRoutingModule { }
